import { createBaseAction } from '@essent/common';
import type { InnogyComponentRendering } from '@core/jss-models';
import { createAction } from '@ngrx/store';

export const enum UsageQuestionnaireTypes {
  OPEN_CALCULATE_QUESTIONNAIRE_MODAL = '[Retention] Open questionnaire modal',
  CLOSE_CALCULATE_QUESTIONNAIRE_MODAL = '[Retention] Close questionnaire modal',
}

export const openQuestionnaireModal =
  createBaseAction<InnogyComponentRendering>(
    UsageQuestionnaireTypes.OPEN_CALCULATE_QUESTIONNAIRE_MODAL
  );

export const closeQuestionnaireModal = createAction(
  UsageQuestionnaireTypes.CLOSE_CALCULATE_QUESTIONNAIRE_MODAL
);
